export enum ThresholdUnit {
  PERCENTAGE = 'PERCENTAGE',
  KG = 'KG',
}

export type MarsdenThresholdUnit = ThresholdUnit.PERCENTAGE | ThresholdUnit.KG;

export type MirPefThresholdUnit = ThresholdUnit.PERCENTAGE;
